import Dropdown from './dropdown.element.js';

export default Dropdown;

Dropdown.define('wje-dropdown', Dropdown);
